<div class="dialog-container">
  <div class="company-header">
    <div class="company-logo">
      <img
      [src]="'data:image/png;base64,' + company.logoBase64"
      alt="{{ company.name }} logo"
      />
    </div>
    <h3 class="company-name">{{ company.name }}</h3>
  </div>

  <button mat-icon-button (click)="onClose()" class="close-btn">
    <mat-icon>close</mat-icon>
  </button>

  <h2 mat-dialog-title [class.empty-title]="!internship.internshipTitle">
    <span class="title-span">{{ internship.internshipTitle || 'Internship Position' }}</span>
    <span class="separator"> - </span>
    <span>{{ internship.position }}</span>
    <span class="separator"> - </span>
    <span class="department">{{ internship.department }}</span>
  </h2>

  <div class="info-internship">  
    <p>{{ internship.country?.name || internship.city?.country?.name || 'N/A' }}, {{ internship.city?.name || 'N/A' }}</p>
    <p> {{internship.email}} </p>
  </div>

  <mat-dialog-content>
    <div class="details-grid">
      <p class="internship-description"> {{internship.description}} </p>
    </div>
  </mat-dialog-content>

</div>

